import { actionTypes } from './types/modal'

export const open = id => dispatch => {
  dispatch({ type: actionTypes.OPEN, payload: id })
}

export const close = id => dispatch => {
  dispatch({ type: actionTypes.CLOSE, payload: id })
}
